type MuiTabsType = { [k: string]: any };

const MuiTabs: MuiTabsType = {
  indicator: {
    height: '4px',
  },
};

export default MuiTabs;
